import styles from './Support.module.css';
import support_illustration from '../../assets/img_support.png';
import { Link } from 'react-router-dom';

export default function Support() {
    return (
        <main>
            <section className={styles.pageSection} aria-label="고객지원">
                <div className={styles.content}>
                    <h1 className={styles.title}>고객지원</h1>
                    <p className={styles.desc}>FAQ, 1:1 문의를 통해 편리하게 문제를 해결하세요.</p>

                    <section className={styles.gridWrap}>
                        <div className={styles.grid}>
                            {/* 자주 묻는 질문 */}
                            <div className={styles.card}>
                                <h3>자주 묻는 질문</h3>
                                <p>많은 사용자들이 궁금해 하는 질문을 확인해보세요.</p>
                                <Link to="/support/faqs" className={styles.btn}>
                                    바로가기
                                </Link>
                            </div>

                            {/* 1:1 문의 */}
                            <div className={styles.card}>
                                <h3>1:1 문의</h3>
                                <p>
                                    서비스 관련 문의를 접수하시면 빠르게 답변해드립니다. <br />
                                    운영 시간: 평일 9:00~18:00
                                </p>
                                <Link to="/support/inquiries" className={styles.btn}>
                                    바로가기
                                </Link>
                            </div>

                            {/* 사용자 매뉴얼 다운로드 */}
                            <div className={styles.card}>
                                <h3>사용자 매뉴얼</h3>
                                <p>서비스 이용 방법을 자세히 확인할 수 있는 사용자 매뉴얼을 내려받을 수 있습니다.</p>
                                <a href="/uploads/user_manual.pdf" className={styles.btn} target="_blank" rel="noopener noreferrer">
                                    매뉴얼 다운로드
                                </a>
                            </div>
                        </div>
                    </section>
                </div>

                <div className={styles.image}>
                    <img src={support_illustration} alt="고객지원 안내 일러스트" />
                </div>
            </section>
        </main>
    );
}
